export var ImageCacheStrategyDTO;
(function (ImageCacheStrategyDTO) {
    ImageCacheStrategyDTO["perloadAll"] = "preload_all";
    ImageCacheStrategyDTO["lazyLoad"] = "lazy_load";
})(ImageCacheStrategyDTO || (ImageCacheStrategyDTO = {}));
